import AppRoute from './app/routes';

function App() {
  return (
  <>
    <AppRoute />
  </>
  );
}

export default App;
